<template>
    <div>
        <HeaderNews></HeaderNews>
        <div class="news-content">
            <router-view></router-view>
        </div>
        <div class="footer_con" style="" v-if="deviceType == 'PC'">
            <Footer />
        </div>
        <div style="color:#fff" v-else>
            <FooterDom />
        </div>
    </div>
</template>

<script>
import HeaderNews from './HeaderNews.vue'
import Footer from '../../components/Footer.vue';
import FooterDom from '../../components/mobile/FooterDom.vue';

import { getDeviceType } from '../../utils/index'

export default {
    name: "NewsLayout",
    data() {
        return {
            deviceType: 'PC',
        };
    },
    components: {
        HeaderNews, Footer, FooterDom
    },
    mounted() {
        this.deviceType = getDeviceType()
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style scoped>
.news-content {
    padding: 80px 0 40px 0;
    background: #f8fafc;
}

.footer_con {
    width: 100%;
    height: 644px;
    background-image: linear-gradient(#b4e0f9, #6cb1ff);
}
</style>
